import { axiosInstanceV2 } from "@src/shared/api";
import { useAuthStore } from "@src/entities/login/model/store/authStore";
import { REQUEST_HH_API_URL } from "../constants";

export const cancelStructuredVacancy = async () => {
  const access_token = useAuthStore.getState().user?.tokens.access_token;

  const response = await axiosInstanceV2.post(
    REQUEST_HH_API_URL.cancelStructuredVacancy(),
    null,
    {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    },
  );

  return response;
};
